import React from "react";
import WagerTypeButtons from "./WagerTypeButtons";

const WagerTypes = ({ raceInfo, setRaceInfo, lengthRaces }) => {
  const onChangeWT = (enabled, nameWT) => {
    raceInfo[nameWT] = enabled;
    setRaceInfo({ ...raceInfo });
  };

  let wagerTypesButtons = [];

  if (raceInfo.Win) {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"win"}
        status={true}
        wt={"Win"}
        wagerName={"WN"}
        onChangeWT={onChangeWT}
      />
    );
  } else {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"win"}
        status={false}
        wt={"Win"}
        wagerName={"WN"}
        onChangeWT={onChangeWT}
      />
    );
  }

  if (raceInfo.Place) {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"pl"}
        status={true}
        wt={"Place"}
        wagerName={"PL"}
        onChangeWT={onChangeWT}
      />
    );
  } else {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"pl"}
        status={false}
        wt={"Place"}
        wagerName={"PL"}
        onChangeWT={onChangeWT}
      />
    );
  }

  if (raceInfo.Show) {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"sh"}
        status={true}
        wt={"Show"}
        wagerName={"SH"}
        onChangeWT={onChangeWT}
      />
    );
  } else {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"sh"}
        status={false}
        wt={"Show"}
        wagerName={"SH"}
        onChangeWT={onChangeWT}
      />
    );
  }

  if (raceInfo.Exacta) {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"es"}
        status={true}
        wt={"Exacta"}
        wagerName={"EX"}
        onChangeWT={onChangeWT}
      />
    );
  } else {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"ex"}
        status={false}
        wt={"Exacta"}
        wagerName={"EX"}
        onChangeWT={onChangeWT}
      />
    );
  }

  if (raceInfo.Trifecta) {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"tr"}
        status={true}
        wt={"Trifecta"}
        wagerName={"TRI"}
        onChangeWT={onChangeWT}
      />
    );
  } else {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"tr"}
        status={false}
        wt={"Trifecta"}
        wagerName={"TRI"}
        onChangeWT={onChangeWT}
      />
    );
  }

  if (raceInfo.Superfecta) {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"sp"}
        status={true}
        wt={"Superfecta"}
        wagerName={"SU"}
        onChangeWT={onChangeWT}
      />
    );
  } else {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"sp"}
        status={false}
        wt={"Superfecta"}
        wagerName={"SU"}
        onChangeWT={onChangeWT}
      />
    );
  }

  if (raceInfo.Quinella) {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"qn"}
        status={true}
        wt={"Quinella"}
        wagerName={"QU"}
        onChangeWT={onChangeWT}
      />
    );
  } else {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"qn"}
        status={false}
        wt={"Quinella"}
        wagerName={"QU"}
        onChangeWT={onChangeWT}
      />
    );
  }

  if (lengthRaces !== raceInfo.RaceNumber) {
    if (raceInfo.DailyDouble) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"2"}
          status={true}
          wt={"DailyDouble"}
          wagerName={"DD"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"2"}
          status={false}
          wt={"DailyDouble"}
          wagerName={"DD"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.RaceNumber + 3 <= lengthRaces + 1) {
    if (raceInfo.Pick3) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"3"}
          status={true}
          wt={"Pick3"}
          wagerName={"P3"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"3"}
          status={false}
          wt={"Pick3"}
          wagerName={"P3"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.RaceNumber + 4 <= lengthRaces + 1) {
    if (raceInfo.Pick4) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"4"}
          status={true}
          wt={"Pick4"}
          wagerName={"P4"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"4"}
          status={false}
          wt={"Pick4"}
          wagerName={"P4"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.RaceNumber + 5 <= lengthRaces + 1) {
    if (raceInfo.Pick5) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"5"}
          status={true}
          wt={"Pick5"}
          wagerName={"P5"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"5"}
          status={false}
          wt={"Pick5"}
          wagerName={"P5"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.RaceNumber + 6 <= lengthRaces + 1) {
    if (raceInfo.Pick6) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"6"}
          status={true}
          wt={"Pick6"}
          wagerName={"P6"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"6"}
          status={false}
          wt={"Pick6"}
          wagerName={"P6"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.RaceNumber + 7 <= lengthRaces + 1) {
    if (raceInfo.Pick7) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"7"}
          status={true}
          wt={"Pick7"}
          wagerName={"P7"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"7"}
          status={false}
          wt={"Pick7"}
          wagerName={"P7"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.RaceNumber + 8 <= lengthRaces + 1) {
    if (raceInfo.Pick8) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"8"}
          status={true}
          wt={"Pick8"}
          wagerName={"P8"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"8"}
          status={false}
          wt={"Pick8"}
          wagerName={"P8"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.RaceNumber + 9 <= lengthRaces + 1) {
    if (raceInfo.Pick9) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"9"}
          status={true}
          wt={"Pick9"}
          wagerName={"P9"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"9"}
          status={false}
          wt={"Pick9"}
          wagerName={"P9"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.RaceNumber + 10 <= lengthRaces + 1) {
    if (raceInfo.Pick10) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"10"}
          status={true}
          wt={"Pick10"}
          wagerName={"P10"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"10"}
          status={false}
          wt={"Pick10"}
          wagerName={"P10"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.RaceNumber + 11 <= lengthRaces + 1) {
    if (raceInfo.Pick11) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"11"}
          status={true}
          wt={"Pick11"}
          wagerName={"P11"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"11"}
          status={false}
          wt={"Pick11"}
          wagerName={"P11"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }
  if (raceInfo.RaceNumber + 12 <= lengthRaces + 1) {
    if (raceInfo.Pick12) {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"12"}
          status={true}
          wt={"Pick12"}
          wagerName={"P12"}
          onChangeWT={onChangeWT}
        />
      );
    } else {
      wagerTypesButtons.push(
        <WagerTypeButtons
          key={"12"}
          status={false}
          wt={"Pick12"}
          wagerName={"P12"}
          onChangeWT={onChangeWT}
        />
      );
    }
  }

  if (raceInfo.High5) {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"13"}
        status={true}
        wt={"High5"}
        wagerName={"H5"}
        onChangeWT={onChangeWT}
      />
    );
  } else {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"13"}
        status={false}
        wt={"High5"}
        wagerName={"H5"}
        onChangeWT={onChangeWT}
      />
    );
  }

  if (raceInfo.Omni) {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"14"}
        status={true}
        wt={"Omni"}
        wagerName={"On"}
        onChangeWT={onChangeWT}
      />
    );
  } else {
    wagerTypesButtons.push(
      <WagerTypeButtons
        key={"14"}
        status={false}
        wt={"Omni"}
        wagerName={"On"}
        onChangeWT={onChangeWT}
      />
    );
  }

  return (
    <>
      <label className="mr-1 mb-2 lead">Bet Types </label>
      <div className="form-inline">
        <div
          className="btn-group-sm"
          role="group"
          aria-label="button groups sm"
        >
          {wagerTypesButtons}
        </div>
      </div>
    </>
  );
};

export default WagerTypes;
